<template>
  <div class="dropdown" ref="root">
    <div class="dropdown__header-mguu" @click.prevent="toggleDropdown()">
      <slot name="header"> </slot>
    </div>
    <div
      v-if="dropdownIsActive"
      class="dropdown__overlay"
      @click="toggleDropdown"
    ></div>
    <div
      ref="body"
      :class="[
        'dropdown__body',
        { 'dropdown__body--active': dropdownIsActive },
      ]"
    >
      <div class="dropdown__body__closeModal" style="display: none;">
        <div
          class="cancel"
          @click="toggleDropdown"
        >
          Закрыть
        </div>
      </div>
      <slot name="body" />

      <component
        :is="item.component"
        v-for="(item, index) in computedItems"
        :key="index"
        :href="item.href"
        :to="item.to"
        :class="['dropdown__body__item-mguu', {'dropdown__body__item-mguu-last': index === 2 }]"
        @click="
          () => {
            item.onClick ? item.onClick() : ''
            toggleDropdown()
          }
        "
      >

        {{ item.label }}
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
          v-if="index === 2"
        class="dropdown__body__item-mguu__img">
          <path d="M10 13C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11H18.5859L17.293 9.70703C16.9024 9.31651 16.9024 8.68349 17.293 8.29297C17.6835 7.90244 18.3165 7.90244 18.707 8.29297L21.707 11.293C22.0976 11.6835 22.0976 12.3165 21.707 12.707L18.707 15.707C18.3165 16.0976 17.6835 16.0976 17.293 15.707C16.9024 15.3165 16.9024 14.6835 17.293 14.293L18.5859 13H10ZM14 5H6C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H14C14.5523 19 15 19.4477 15 20C15 20.5523 14.5523 21 14 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3H14C14.5523 3 15 3.44772 15 4C15 4.55228 14.5523 5 14 5Z" fill="#12122C"/>
        </svg>
      </component>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, type PropType} from 'vue'
import { RouteMeta } from 'vue-router'

export default {
  name: 'appDropdownMguu',
  props: {
    items: {
      type: Array as PropType<
        {
          label: String
          to?: RouteMeta
          onClick?: () => void
          href?: string
          icon?: Component
        }[]
      >,
      default: [],
    },
    toggleStatus: {
      type: Boolean,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: null,
    },
  },
  data: () => ({
    dropdownIsActive: false,
  }),
  computed: {
    computedItems() {
      return this.items.map((item) => {
        let component = ''
        if (item.to) component = 'router-link'
        if (item.href) component = 'a'
        if (item.onClick) component = 'button'


        return {
          component: component,
          label: item.label,
          onClick: item.onClick,
          href: item.href ? item.href : '',
          to: item.to ? item.to : '',
          icon: item.icon ? item.icon : null,
        }
      })
    },
  },
  methods: {
    closeIfClickedOutside(event: any) {
      if (
        event.target === this.$refs.root ||
        event.composedPath().includes(this.$refs.root) ||
        event.target === this.$refs.body ||
        event.composedPath().includes(this.$refs.body)
      )
        return

      this.dropdownIsActive = false
      this.$emit('update:toggleStatus', false)
    },
    toggleDropdown() {
      if (this.disabled) {
        return;
      }
      this.dropdownIsActive = !this.dropdownIsActive
      this.$emit('toggle', this.dropdownIsActive)
      this.$emit('update:toggleStatus', this.dropdownIsActive)
    },
  },
  watch: {
    toggleStatus: {
      immediate: true,
      handler(val) {
        if (val === null) {
          return;
        }

        this.dropdownIsActive = val
        this.$emit('toggle', !val)
      },
    },
  },
  mounted() {
    window.addEventListener('click', this.closeIfClickedOutside)
  },
  unmounted() {
    window.removeEventListener('click', this.closeIfClickedOutside)
  },
}
</script>

<style lang="scss" src="./AppDropdownMguu.scss" />
<style lang="scss" scoped>
  .cancel {
    background: #e6f2f4;
    color: #00788c;
    border-radius: 9px;
    padding: 8px 10px;
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
  }
</style>